/* Adds an email-workflow payload. Never changes submission, CAPTCHA or analytics.
   Customer creation happens only after Shopify accepts and sends the enquiry email.
   No personal information is stored in browser storage or sent to analytics. */
(() => {
  'use strict';
  const consentText = 'Email me CO2balance news, project updates and carbon market insights.';
  const attach = root => root.querySelectorAll('[data-co2-customer-capture]').forEach(marker => {
    const form = marker.closest('form');
    if (!form || marker.dataset.co2Attached) return;
    marker.dataset.co2Attached = 'true';
    const packet = marker.querySelector('[data-co2-customer-data]');
    const consent = marker.querySelector('[data-co2-newsletter-consent]');
    const field = names => {
      for (const name of names) {
        const input = form.elements.namedItem(name);
        if (typeof input?.value === 'string') return input.value.trim();
      }
      return '';
    };
    const update = () => {
      packet.value = 'CO2CUSTOMERv1:' + JSON.stringify({
        version: 'co2-v1',
        kind: marker.dataset.co2CustomerCapture,
        email: field(['contact[email]']),
        name: field(['contact[Name]', 'contact[name]']),
        firstName: field(['contact[First name]']),
        lastName: field(['contact[Last name]']),
        organisation: field(['contact[Organisation]']),
        sourcePath: location.pathname,
        newsletterOptIn: consent.checked === true,
        consentText: consent.checked ? consentText : ''
      });
    };
    // Update while editing as well as on submit, including Shopify CAPTCHA handover.
    form.addEventListener('input', update);
    form.addEventListener('change', update);
    form.addEventListener('submit', update, true);
    update();
  });
  attach(document);
  document.addEventListener('shopify:section:load', event => attach(event.target));
})();
